import { Block, Button, useStyletron } from "@mezo-org/mezo-clay";
import React, { forwardRef, useMemo } from "react";
const ConnectedTrigger = forwardRef((props, ref) => {
    const { onClick, avatar, size = "medium", ...restProps } = props;
    const [, theme] = useStyletron();
    const avatarSize = useMemo(() => {
        const sizeMap = {
            medium: theme.sizing.scale950,
            large: theme.sizing.scale1400,
        };
        return sizeMap[size];
    }, [theme, size]);
    const buttonPadding = useMemo(() => {
        const paddingMap = {
            medium: theme.sizing.scale0,
            large: theme.sizing.scale100,
        };
        return paddingMap[size];
    }, [theme, size]);
    return (React.createElement(Button, { overrides: {
            BaseButton: {
                props: { ref, ...restProps },
                style: {
                    borderRadius: "100%",
                    overflow: "hidden",
                    padding: buttonPadding,
                },
            },
        }, onClick: onClick }, typeof avatar === "string" ? (React.createElement(Block, { width: avatarSize, height: avatarSize, as: "img", src: avatar, alt: "" })) : (React.createElement(Block, { width: avatarSize, height: avatarSize, overrides: {
            Block: {
                style: {
                    borderRadius: "100%",
                    overflow: "hidden",
                },
            },
        } }, avatar))));
});
export default ConnectedTrigger;
//# sourceMappingURL=ConnectedTrigger.js.map